import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name uploadsService
     * @memberof app
     *
     * @description
     * This is the service for the uploads.
     *
     * @author rowilken.btc
     */
    angular.module('app').service('uploadsService', uploadsService);

    function uploadsService() {
        var UPLOAD_CONTENT = {
            PRODUCT: {
                name: 'Product',
                fallbackEndpointType: 'PRODUCT_DATA_SERVICE'
            },

            NETWORK_POINT: {
                name: 'Network point',
                fallbackEndpointType: 'CONNECTION_POINT_SERVICE'
            },

            REVERSE_AUCTION: {
                name: 'Reverse auction',
                fallbackEndpointType: 'PRODUCT_DATA_SERVICE'
            },

            TRADE_PROPOSAL_STATUS: {
                name: 'Trade / Trade proposal status',
                fallbackEndpointType: 'TRADE_STATUS_CHANGE_NOTIFICATION_SERVICE'
            },

            BALANCING_GROUP: {
                name: 'Balancing group',
                fallbackEndpointType: 'ACCOUNTING_GRID_SERVICE'
            },
            PORTFOLIO_CODE: {
                name: 'Portfolio code',
                fallbackEndpointType: 'PORTFOLIO_CODE_SERVICE'
            }
        };

        var UPLOAD_TYPE = {
            MANUAL: 'Manual (step by step)',
            XML_UPLOAD: 'XML upload'
        };

        var networkPoint;

        function setNetworkPoint(nwp) {
            networkPoint = nwp;
        }

        function getNetworkPoint() {
            return networkPoint;
        }

        var uploadContentType;

        function getUploadContentType() {
            return uploadContentType;
        }

        function setUploadContentType(type) {
            uploadContentType = type;
        }

        return {
            UPLOAD_CONTENT: UPLOAD_CONTENT,
            UPLOAD_TYPE: UPLOAD_TYPE,
            setNetworkPoint: setNetworkPoint,
            getNetworkPoint: getNetworkPoint,
            getUploadContentType: getUploadContentType,
            setUploadContentType: setUploadContentType
        };
    }
})();
